// extracted by mini-css-extract-plugin
export default {"wrapper":"dbVmr","text":"lR2iK","option":"mdFY8","icon":"wgCoj"};